import React from 'react';
import { Link } from 'react-router-dom';
import { KAKAO_TALK_URL } from '../constants/contact';

const StudioFooter: React.FC = () => (
  <footer className="studio-footer">
    <div className="studio-shell">
      <div className="studio-footer-main">
        <Link className="studio-footer-brand" to="/" aria-label="솜니움라이브 홈">
          <img src="/brand-concepts/som/shift-05a-register-dark.svg" alt="" />
          <span>솜니움라이브</span>
        </Link>
        <p>WEB &amp; APP PRODUCTION STUDIO</p>
      </div>
      <div className="studio-footer-details" aria-label="회사 정보">
        <p><span>상호</span> 솜니움라이브</p>
        <p><span>대표자</span> 김은수</p>
        <p><span>사업자등록번호</span> 627-06-03425</p>
        <p><span>주소</span> 경기 성남시 분당구 서현로 210번길 20 405호</p>
      </div>
      <div className="studio-footer-contact" aria-label="연락처">
        <span>CONTACT</span>
        <a href="mailto:contact@somniumlive.com">contact@somniumlive.com</a>
        <a href={KAKAO_TALK_URL} target="_blank" rel="noopener noreferrer">카카오톡 문의 ↗</a>
      </div>
    </div>
    <div className="studio-shell studio-footer-bottom"><span>© {new Date().getFullYear()} SOMNIUM LIVE</span><a href="#top">맨 위로 ↑</a></div>
  </footer>
);

export default StudioFooter;
